import StarIcon from '@mui/icons-material/Star';
import SyncIcon from '@mui/icons-material/Sync';
import WifiIcon from '@mui/icons-material/Wifi';
import { Typography, TypographyProps } from '@mui/material';
import { makeStyles } from 'tss-react/mui';
import { OfflineStatus } from '../modules/offline/domain/offlineOrder/offlineOrder.types';
import { OrderBlockReason, StatusType, VirtualOrderStatus } from '../modules/orders/order.types';
import { useCommonClasses } from '../styles/useCommonClasses.styles';
import Dot from './Dot';

type StatusRendererProps = {
  color: string;
  label: string;
  status: StatusType | OfflineStatus | OrderBlockReason | string;
  size?: 'small' | 'medium' | 'large';
  fontSize?: number;
  typographyProps?: TypographyProps;
};

const useStyles = makeStyles()(() => ({
  starIcon: {
    fontSize: '12px',
  },
}));

const StatusRenderer = ({
  color,
  label,
  size = 'small',
  status,
  fontSize,
  typographyProps,
}: StatusRendererProps) => {
  const { classes: commonClasses } = useCommonClasses();

  const { classes } = useStyles();

  const getIcon = () => {
    if (status === StatusType.SUGGESTED) {
      return <StarIcon className={classes.starIcon} color="primary" />;
    }

    if (status === OfflineStatus.OFFLINE) {
      return <WifiIcon fontSize={size} style={{ color }} />;
    }

    if (status === OfflineStatus.ERROR_SYNCING) {
      return <WifiIcon fontSize={size} style={{ color }} />;
    }

    if (
      status === OfflineStatus.SYNCING ||
      status === VirtualOrderStatus.MASS_ACTION_STATUS_UPDATING
    ) {
      return <SyncIcon fontSize={size} style={{ color }} className={commonClasses.rotating} />;
    }

    return <Dot size={size} color={color} />;
  };

  return (
    <div
      style={{
        columnGap: '6px',
        width: '100%',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'flex-start',
      }}
    >
      {getIcon()}

      <Typography style={{ fontSize }} component="span" noWrap {...typographyProps}>
        {label}
      </Typography>
    </div>
  );
};

export default StatusRenderer;
